// composables/useNotifications.js
// Module-scoped reactive singleton for unread state. Shared across ChatWidget + ChatLauncher.
import { reactive } from 'vue'
import { getUnread, markRead } from '../services/notificationsApi'

const state = reactive({
  unreadCount: 0,
  items: [] // assistant ChatMessage[] the user hasn't read
})

async function fetchUnread(apiKey) {
  try {
    const data = await getUnread(apiKey)
    state.unreadCount = data.count ?? 0
    state.items = Array.isArray(data.messages) ? data.messages : []
  } catch (e) {
    console.error('[notifications] fetchUnread failed', e)
  }
}

// Add a live-arriving message to the badge. Dedupe by id.
function addIncoming(message) {
  if (!message) return
  if (message.id && state.items.some(m => m.id === message.id)) return
  state.items.unshift(message)
  state.unreadCount += 1
}

// Mark a whole session read, then re-sync the count from the server.
async function markSessionRead(apiKey, sessionId) {
  if (!apiKey || !sessionId) return
  try {
    await markRead(apiKey, { sessionId })
  } catch (e) {
    console.error('[notifications] markSessionRead failed', e)
  }
  await fetchUnread(apiKey)
}

// Mark specific message ids read, then re-sync.
async function markIdsRead(apiKey, ids) {
  if (!apiKey || !ids || ids.length === 0) return
  try {
    await markRead(apiKey, { messageIds: ids })
  } catch (e) {
    console.error('[notifications] markIdsRead failed', e)
  }
  await fetchUnread(apiKey)
}

export function useNotifications() {
  return { state, fetchUnread, addIncoming, markSessionRead, markIdsRead }
}
